export function makeFromObjectMap<
    TOptionModel
>(objectMap: Record<string, TOptionModel>,) {
  return Object.entries(objectMap).map(([key, item]) => ({ key, item }));
}
